import { useEffect, useState } from "react";
import axios from "axios";
import Results from "@/screens/Results";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Read-only public report at /audit/:id — shareable link for Celeste (or the founder)
 * to open the full editorial diagnosis in a browser. The Book-A-Call / Dubsado CTA
 * is hidden here (readonly mode) so it's a pure report.
 */
export default function PublicAudit() {
  const id = window.location.pathname.replace(/^\/audit\//, "").split(/[/?#]/)[0];
  const [state, setState] = useState({ loading: true, error: null, data: null });

  // Fetch on mount / when the id changes. Other refs are safe to close over.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (!id) {
      setState({ loading: false, error: "Missing audit id", data: null });
      return;
    }
    axios
      .get(`${API}/assessment/${id}`)
      .then((r) => {
        const d = r.data;
        setState({
          loading: false,
          error: null,
          data: {
            id: d.id,
            diagnosis: d.diagnosis,
            critique: d.critique,
            prescription: d.prescription,
            gaps: d.gaps || {},
            email_status: d.email_status || {},
            site_data: d.site_data || {},
            lead: {
              name: d.name,
              email: d.email,
              business_name: d.business_name,
              website_url: d.website_url,
            },
          },
        });
      })
      .catch((e) => {
        const msg = e?.response?.data?.detail || "Report not found";
        setState({ loading: false, error: msg, data: null });
      });
  }, [id]);

  if (state.loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="section-label">Loading report…</div>
      </div>
    );
  }
  if (state.error || !state.data) {
    return (
      <div className="min-h-screen flex items-center justify-center px-6">
        <div className="stage text-center">
          <div className="section-label mb-4">Report</div>
          <h1 className="font-serif text-4xl font-light display-tight">
            {state.error || "Report not found"}
          </h1>
        </div>
      </div>
    );
  }

  const { data } = state;

  // Backend may not include the full gaps dict; if empty, we need it for rendering.
  // The Results component expects `result.gaps` — if missing, fetch config once.
  return (
    <div>
      {/* Small "prepared for" banner at the top */}
      <div className="bg-[#F3F3F3] border-b border-[#E5E5E5] py-3 px-6 md:px-12 text-center">
        <div className="section-label">
          Read-only report — prepared for {data.lead.business_name}
        </div>
      </div>
      <Results
        result={data}
        lead={data.lead}
        onRestart={() => (window.location.href = "/")}
        readonly
      />
    </div>
  );
}
